export default __webpack_public_path__ + "static/media/caret-down-solid.f5845b07.svg";